var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5105_1845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.875C6.5 9.875 4.375 7.625 4.375 4.875C4.375 2.25 6.625 0 9.375 0C12.125 0 14.25 2.25 14.25 5C14.125 7.625 11.875 9.875 9.25 9.875ZM9.25 1.375C7.375 1.375 5.75 3 5.75 4.875C5.75 6.75 7.25 8.375 9.25 8.375C11.25 8.375 12.75 6.875 12.75 4.875C12.75 3 11.125 1.375 9.25 1.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.375 20C4.125 20 3 20 1.75 20C0.625 20 0 19.25 0 18.25C0 17.125 0 16.125 0 15C0 14.25 0.25 13.75 0.875 13.5C2.75 12.5 4.625 11.875 6.625 11.625C8.25 11.375 9.875 11.375 11.5 11.625C11.875 11.625 12.25 12 12.125 12.375C12.125 12.75 11.75 13 11.375 13C10.5 13 9.5 12.875 8.625 12.875C6.125 12.875 3.75 13.625 1.625 14.75C1.5 14.75 1.5 14.875 1.5 15C1.5 16.125 1.5 17.125 1.5 18.25C1.5 18.5 1.5 18.5 1.875 18.5C3 18.5 4.25 18.5 5.375 18.5C6.625 18.5 13 18.5 14.25 18.5C14.625 18.5 14.875 18.625 15 19C15.25 19.5 14.875 20 14.25 20C12.875 20 6.625 20 5.375 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 12.75C16 13.125 15.75 13.5 15.375 14C15.25 14.25 15 14.375 14.75 14.25C14.5 14.25 14.25 14.125 14.125 13.875C14 13.625 14 13.375 14.25 13.125C14.875 12.375 15.5 11.625 16.125 10.875C16.25 10.75 16.375 10.5 16.5 10.375C16.875 10 17.25 10 17.625 10.375C18.375 11.25 19.125 12.25 19.875 13.125C20 13.375 20.125 13.625 20 13.875C19.875 14.125 19.75 14.25 19.375 14.375C19.125 14.375 18.875 14.25 18.75 14.125C18.375 13.75 18.125 13.25 17.625 12.875C17.625 13 17.625 13.125 17.625 13.125C17.625 14.5 17.625 16 17.625 17.375C17.625 18.625 16.75 19.625 15.625 19.875C15.5 19.875 15.25 20 15.125 20C14.375 20 13.5 20 12.75 20C12.375 20 12.125 19.75 12 19.375C12 19 12.125 18.75 12.375 18.625C12.5 18.625 12.625 18.625 12.75 18.625C13.5 18.625 14.125 18.625 14.875 18.625C15.75 18.625 16.125 18.125 16.125 17.375C16.125 16 16.125 14.5 16.125 13.125C16.375 12.875 16.375 12.875 16.375 12.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5105_1845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.125,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleupload);
export default __webpack_public_path__ + "static/media/single upload.82d70e8b6da661e1bbd4db6adbc2a469.svg";
export { ForwardRef as ReactComponent };